import { create as tsclient } from 'timesync'
import { Person, PersonMenu, Item } from 'src/graphql/types'

const ts = tsclient({ server: '/api/timesync', interval: null })
// ts.on('change', (offset: number) => { console.log(`timesync changed offset: ${offset} ms`) })
// ts.on('change', () => { console.log(new Date(ts.now())) })
ts.sync()

const store = {

  state: {
    person: {} as Person,
    profile: '',
    presenter: {
      item: {} as Item
    }
  },

  viewport: {
    width: null as number | null,
    height: null as number | null
  },

  now () {
    return new Date(ts.now())
  },

  setPerson (value: Person) {
    this.state.person = Object.assign(this.state.person, value)
    this.state.profile = this.state.profile || this.state.person.profileMenu || ''
    if (this.state.profile === PersonMenu.Presenter && this.state.person.profileMenu === PersonMenu.Attendee) {
      this.state.profile = PersonMenu.Attendee
    }
    if (this.state.profile === PersonMenu.Attendee && this.state.person.profileMenu === PersonMenu.Presenter) {
      this.state.profile = PersonMenu.Presenter
    }
  },

  setProfile (value: string) {
    this.state.profile = value
  },

  presenterInit (item: Item) {
    this.state.presenter.item = item
  },

  presenterSetItem(item: Item) {
    this.state.presenter.item = Object.assign(this.state.presenter.item, item)
  }
}

export default store

// @ts-ignore
if (typeof (window.visualViewport) === 'object') {
  // @ts-ignore
  window.visualViewport.addEventListener('resize', () => {
    // @ts-ignore
    store.viewport.width = window.visualViewport.width
    // @ts-ignore
    store.viewport.height = window.visualViewport.height
  })
}
